import gql from "graphql-tag";

import { ENTITY_VALUES_FRAGMENT } from "@arachnys/flow-app/src/page/EntityDetail/queries";

export const GET_ENTITY_PREVIEW_DATA = gql`
    query GetEntityPreview {
        dispositionInfoBar @client {
            id
            itemId
            show
        }
    }
`;

export const GET_ENTITY_DETAILS = gql`
    query DispositionEntityDetails($id: ID!) {
        entity(id: $id) {
            ...EntityValues
        }
        EntitySchema: jsonSchema(schema: "arachnys.entities.Entity")
    }
    ${ENTITY_VALUES_FRAGMENT}
`;
